import { useCallback } from 'react'

import { TriageScreenerNames } from '../../../models'

export const useGetEstimatedGenAiHeaderLines = (screener: string | undefined) => {
  const getEstimatedLines = useCallback(() => {
    let estimatedLinesDesktop = 1
    let estimatedLinesMobile = 1
    switch (screener) {
      case TriageScreenerNames.PRIMARY_NEEDS:
        estimatedLinesDesktop = 1
        estimatedLinesMobile = 1
        break
      case TriageScreenerNames.WORD_CLOUD_1:
        estimatedLinesDesktop = 3
        estimatedLinesMobile = 5
        break
      case TriageScreenerNames.WORD_CLOUD_2:
      case TriageScreenerNames.INTENSITY:
        estimatedLinesDesktop = 1
        estimatedLinesMobile = 2
        break
      case TriageScreenerNames.WORK_LIFE:
        estimatedLinesDesktop = 2
        estimatedLinesMobile = 5
        break
      case TriageScreenerNames.CARE_EXPERIENCES:
        estimatedLinesDesktop = 1
        estimatedLinesMobile = 1
        break
      case TriageScreenerNames.CLINICAL_SCREENERS:
        estimatedLinesDesktop = 5
        estimatedLinesMobile = 8
        break
      default:
        break
    }
    return { desktop: estimatedLinesDesktop, mobile: estimatedLinesMobile }
  }, [screener])

  return getEstimatedLines
}
